export const types = ['NUMBER', 'DECIMAL', 'IDENTIFIER', 'DATE', 'TEXT', 'VAR_PRIMARY'];
export const typeDescriptions = ['número', 'decimal', 'identificador', 'data', 'texto', 'constante global'];

export const getTypeDescription = (type) => {
  if (!type) return undefined;
  const index = types.indexOf(type);
  return index !== -1 ? typeDescriptions[index] : undefined;
};
